import { MensajesGenericos_EN } from './Genericos/DiccionarioMensajesGenericos_EN';

const Diccionario_EN = [
    {
        'codigo': 'ErrorActualizarClave',
        'mensaje': 'There were problems recovering the password.'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'The password field is empty.'
    },
    {
        'codigo': 'ErrorEmailNotFound',
        'mensaje': 'The email account was not found.'
    },
    {
        'codigo': 'ErrorEstLogin',
        'mensaje': 'There were problems logging in.'
    },
    {
        'codigo': 'ErrorGetingDefaultCompany',
        'mensaje': 'There were problems getting company data.'
    },
    {
        'codigo': 'ErrorGetingDefaultCompanyDB',
        'mensaje': 'There were problems getting company data.'
    },
    {
        'codigo': 'ErrorProfLogin',
        'mensaje': 'There were problems logging in.'
    },
    {
        'codigo': 'ErrorUserUnauthorized',
        'mensaje': 'The user is not authorized, please check your credentials.'
    },
    {
        'codigo': 'UnauthorizedPass',
        'mensaje': 'The user is not authorized, please check your credentials.'
    },
    {
        'codigo': 'UnauthorizedUser',
        'mensaje': 'The user is not authorized, please check your credentials.'
    },
    {
        'codigo': 'UserWithoutRoles',
        'mensaje': 'The user does not have defined permissions.'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'There were problems recovering the password.'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Password changed successfully.'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'The user field is empty.'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'The password field is empty.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'File format (extension) not allowed.'
    },
    {
        'codigo': 'ErrorUserEmpty',
        'mensaje': 'You must enter your username.'
    },
];

export const DiccionarioMensajes_EN = [...MensajesGenericos_EN, ...Diccionario_EN];